module.exports = __webpack_public_path__ + "assets/logo.49a6a5348362893ae0ff9458b5a5fb46.png";